export default __webpack_public_path__ + "static/media/SeaLife_04.c29290b1.png";